import { render } from "./Question0203.vue?vue&type=template&id=3ef0b9a2&scoped=true&lang=true"
import script from "./Question0203.vue?vue&type=script&lang=js"
export * from "./Question0203.vue?vue&type=script&lang=js"

import "./Question0203.vue?vue&type=style&index=0&id=3ef0b9a2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef0b9a2"]])

export default __exports__